import React, { useCallback } from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { DataSetEditSqlServerIntegrationHook } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditSqlServerIntegration';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { useCrudOperations } from 'apps/sigma2-ui/src/data-wizard/components/composite-dataset/recipes/use-crud-operations';
import { SqlServerIntegrationQuery } from 'libs/end-to-end/src/types/databases/integrations/sql-server-integration';

export const DataSetSqlServerConfigurationQueryListComponent = ({
  sqlServerIntegrationHook,
}: {
  sqlServerIntegrationHook: DataSetEditSqlServerIntegrationHook;
}) => {
  const language = useLanguage();

  const queries = sqlServerIntegrationHook.sqlServerIntegration.queries ?? [];

  const setQueries = useCallback(
    (newQueries: SqlServerIntegrationQuery[]) => {
      sqlServerIntegrationHook.setSqlServerIntegration({
        ...sqlServerIntegrationHook.sqlServerIntegration,
        queries: newQueries.length > 0 ? newQueries : undefined,
      });
    },
    [sqlServerIntegrationHook],
  );

  const crudOps = useCrudOperations({
    items: queries,
    setItems: setQueries,
  });

  return (
    <>
      <S2Typography variant={'headline-3'} translatedContent={'Queries'} />
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            crudOps.onAdd({
              name: '',
              query: '',
              database: undefined,
            });
          },
        }}
        text={'Add Query'}
      />
      <Table
        items={queries}
        columnDefinitions={[
          {
            id: 'name',
            header: () => <div>Name</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'name'}
                value={item.name}
                aria-label={'query name'}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    name: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'query',
            header: () => <div>Query</div>,
            cell: ({ item, rowIndex }) => (
              <textarea
                className="form-textarea"
                key={'query'}
                value={item.query}
                aria-label={'query'}
                rows={4}
                style={{ width: '100%', minWidth: '300px' }}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    query: event.target.value,
                  });
                }}
              />
            ),
          },
          {
            id: 'database',
            header: () => <div>Database</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'database'}
                value={item.database ?? ''}
                aria-label={'database'}
                onChange={(event) => {
                  crudOps.onEdit(rowIndex, {
                    database: event.target.value || undefined,
                  });
                }}
              />
            ),
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ rowIndex }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    crudOps.onDelete(rowIndex);
                  },
                }}
                text={'Remove'}
              />
            ),
          },
        ]}
      />
    </>
  );
};
